let checkbox = document.querySelectorAll('input[type="checkbox"]');
let textbox = document.getElementById('cart-shopnumber');
let namebox = document.getElementById('cart-shopname');
let submit = document.getElementById('checkout');

submit.disabled = true;

for (let i = 0; i < checkbox.length; i++) {
  checkbox[i].addEventListener('change', (event) => {
    let count = 0;
    for (let i = 0; i < checkbox.length; i++) {
      if (checkbox[i].checked) {
        count++;
      }
    }

    if((textbox.value.match(/[^a-zA-Z0-9]/) && textbox.value.length != 10 && (namebox.value.length == null || namebox.value.length == "")) || (textbox.value.match(/[^a-zA-Z0-9]/) || textbox.value.length != 10 || (namebox.value.length == null || namebox.value.length == "")) || count != checkbox.length) {
      submit.disabled = true;
    }
    else{
      submit.disabled = false;
    }
  });
  textbox.addEventListener('input', (event) => {
    if((textbox.value.match(/[^a-zA-Z0-9]/) && textbox.value.length != 10 && (namebox.value.length == null || namebox.value.length == "")) || (textbox.value.match(/[^a-zA-Z0-9]/) || textbox.value.length != 10 || (namebox.value.length == null || namebox.value.length == "")) || !checkbox[0].checked) {
      submit.disabled = true;
    }
    else{
      submit.disabled = false;
    }
  });
    namebox.addEventListener('input', (event) => {
    if((textbox.value.match(/[^a-zA-Z0-9]/) && textbox.value.length != 10 && (namebox.value.length == null || namebox.value.length == "")) || (textbox.value.match(/[^a-zA-Z0-9]/) || textbox.value.length != 10 || (namebox.value.length == null || namebox.value.length == "")) || !checkbox[0].checked) {
      submit.disabled = true;
    }
    else{
      submit.disabled = false;
    }
  });
}